import styled from 'styled-components';
import { Row, Col } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import {
  notableStaffCompanyName,
  selectCompanyStaff,
  selectCompanyStaffLoading,
  selectNotableStaff,
  selectNotableStaffCount,
  selectNotableStaffExportLoading,
  selectNotableStaffLoading,
  selectNotableStaffTitle,
} from 'Selector/CompaniesSelector';
import { Executive } from 'Types/PersonTypes';
import { StaffBuyerGroup } from 'Types/CompaniesTypes';
import BuyerGroupSkeleton from 'Components/common/skeleton/BuyerGroupSkeleton';
import PersonSkeleton from 'Components/common/skeleton/PersonSkeleton';
import { backgroundColorParsing, formatNumberWithCommas } from 'Utils/UtilityFunctions';
import React, { useEffect } from 'react';
import PeopleCardList from 'Components/common/components/PeopleCardList';
import { PeopleNotFound } from 'Pages/people/PeopleGroupDetail';
import ArrowRightIcon from 'Components/common/assets/svgIcons/ArrowRightIcon';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { actions } from 'Slice/CompaniesSlice';
import SkeletonCustom from 'Components/common/skeleton/SkeletonCustom';
import PeopleCardListSkeleton from 'Components/common/skeleton/PeopleCardListSkeleton';
import GlobalButton from 'Components/common/components/GlobalButton';
import ExportIcon from 'Components/common/assets/svgIcons/ExportIcon';
import DragWrapper from 'Components/people/components/DragWrapper';
import { FILE_DOWNLOAD_FAIL, FILE_DOWNLOAD_SUCCESS, NOTABLE_STAFF_ROUTE } from 'Utils/Constants';
import { selectDisclessPersonality } from 'Selector/GlobalSearchContentSelector';
import PeopleCardLarge from '../../common/components/PeopleCardLarge';
import BuyerGroupCard from '../../common/components/BuyerGroupCard';
import {
  primaryColor, primaryHeadingColor, wLight,
  secondaryFont, wMedium, maxWidth, retina, maxWidth1300, maxMobile, maxTablet,
} from '../../../Utils/utilsStyle';

const Wrapper = styled.div`
h2{
  color:${primaryHeadingColor};
  font-size:28px;
  font-weight:${wLight};
  font-family:${secondaryFont};
  margin-bottom:25px;
  @media all and (max-width: ${maxWidth1300}) , ${retina} {
    font-size: 22px;
  }
}
 .heading-text {
   display:flex;
   justify-content:space-between;
 }
.finincal-detail{
    color: ${primaryColor};
    font-weight:${wLight};
    font-family:${secondaryFont};
    font-size:14px;
    padding:4px 0;
    svg{
      g{
        fill:#1EC252;
      }
    }
 }
 .executives-row{
   background-color:#fff;
   border-radius: 16px;
   padding: 36px 40px 50px 40px;
   margin-bottom:60px;
   margin-top:30px;
 }
 .filter-btn{
   max-height: 38px;
   h2{
     margin:0;
   }
 }
 .mb-90{
   margin-bottom: 90px;
 }
 .export_btn{
  padding: 5px 15px 5px 15px;
 }
 .staff-i-follow, .heading-here, .staff-buyers-group {
  h2 {
    @media all and (max-width: ${maxMobile}) { 
      font-size: 18px;
    }
  }
 }
 .export-company {
  .export_btn {
    svg {
      width: 14px;
      min-width: 14px;
      margin-right: 10px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        width: 12px;
        min-width: 12px;
      }
    }
    }
    @media all and (max-width: ${maxTablet}){ 
      width: 30px;
      padding-right: 45px;
      .export_btn {
        width: 30px;
        min-width: 30px;
        height: 28px;
        padding: 0px 9px;
        svg {
          width: 11px;
          min-width: 11px;
        }
      }
    }
  }
`;
const ReadMore = styled.span`
  font-size: 14px;
  font-weight: ${wMedium};
  font-family: ${secondaryFont};
  line-height: 36px;
  letter-spacing: -0.35px;
  color: ${primaryColor};
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: flex-end;
   svg {
    margin-left: 10px;
      @media all and (max-width: ${maxWidth}) , ${retina} {
        margin-left: 5px;
        width: 12px;
        height: 12px;
      }
  }
`;

export interface Props {
  isDrag: (d: boolean) => void,
}

const CompanyStaff = function CompanyStaff(props: Props) {
  const { isDrag } = props;
  const [searchParams] = useSearchParams();
  const companyId = searchParams.get('companyId');
  const companyIdParsed = companyId ? parseInt(companyId, 10) : 0;
  const companyStaff = useSelector(selectCompanyStaff);
  const isLoading = useSelector(selectCompanyStaffLoading);
  const notableStaff = useSelector(selectNotableStaff);
  const notableStaffLoading = useSelector(selectNotableStaffLoading);
  const notableStaffTitle = useSelector(selectNotableStaffTitle);
  const staffCompanyName = useSelector(notableStaffCompanyName);
  const disclessPersonality = useSelector(selectDisclessPersonality);

  const notableStaffExportLoading = useSelector(selectNotableStaffExportLoading);

  const count = useSelector(selectNotableStaffCount);
  const formattedStaffCount = formatNumberWithCommas(count);

  const navigate = useNavigate();
  const dispatch = useDispatch();
  useEffect(() => {
    if (companyIdParsed !== 0) {
      dispatch(actions.getNotableStaff({
        companyId: companyIdParsed,
        page: 1,
      }));

      if (!companyStaff) {
        dispatch(actions.getCompanyStaff({ companyId: companyIdParsed }));
      }
    }
  }, [companyIdParsed]);

  useEffect(() => {
    dispatch(actions.setStaffCall(true));
  }, []);

  const returnBuyersGroupPart = (staffData: StaffBuyerGroup) => (
    <div className="staff-buyers-group">
      <h2 className="mt-c-30">
        {staffData?.title?.length ? staffData.title : 'N/A'}
      </h2>
      <Row gutter={16}>
        {staffData.data?.map((group) => (
          <Col key={group.groupId} span={6} lg={{ span: 6 }} xs={{ span: 24 }} sm={{ span: 12 }}>
            <BuyerGroupCard
              groupName={group.groupName}
              groupPersona={group.groupPersonality}
              persons={group.persons}
              companies={group.companyLogos}
              groupId={group.groupId}
              members={group.personsCount}
              isShared={group.groupShared}
              sharedBy={group.sharedByFirstName}
            />
          </Col>
        ))}
      </Row>
    </div>
  );

  const returnLoader = () => {
    const buyerGroupSkeletons = [];
    const executivesSkeletons = [];
    for (let i = 0; i < 8; i += 1) {
      buyerGroupSkeletons.push(
        <Col span={6} lg={{ span: 6 }} xs={{ span: 24 }} sm={{ span: 12 }} key={`skel${i}`}>
          <BuyerGroupSkeleton />
        </Col>,
      );
    }
    for (let i = 0; i < 12; i += 1) {
      executivesSkeletons.push(
        <Col xxl={{ span: 4 }} xl={{ span: 4 }} lg={{ span: 6 }} key={`skel${i}`}>
          <PersonSkeleton />
        </Col>,
      );
    }

    return (
      <>
        <div style={{
          marginTop: '20px',
        }}
        >
          <Row gutter={16}>
            {buyerGroupSkeletons}
          </Row>
        </div>
        <div style={{
          marginTop: '20px',
        }}
        >
          <Row gutter={46} className="Grid-width-row col-six-fix-md">
            {executivesSkeletons}
          </Row>
        </div>
      </>
    );
  };
  const getExecutives = (executives: Executive[]) => {
    if (executives?.length) {
      return executives
        .slice(0, 15).map((item) => (
          <Col span={8} xs={24} sm={24} md={12} lg={8}>
            <DragWrapper key={item.personId} isDrag={isDrag}>
              <PeopleCardList
                executive={item}
                key={item.personId}
                disableNavigation={false}
                personName={item.personName}
                logo={item.personImage}
                persona={item.archeType.color}
                tag={item.personDesignation}
                personAddedFlag={item.personAdded}
                personId={item.personId}
                executiveType={item.executiveType}
                companyName={item.companyName}
                personalityTypesColors={item.personalityTypes}
                wrapperColor={
                  backgroundColorParsing(item.personalityTypes)
                }
                showDrawerIcon={!!item.personNotes}
              />
            </DragWrapper>
          </Col>
        ));
    }
    return <PeopleNotFound>No Results found</PeopleNotFound>;
  };

  const handleExport = () => {
    dispatch(actions.getExportNotableStaff({
      companyId: companyIdParsed,
      companyName: staffCompanyName,
    }));
  };

  return (
    <Wrapper className='select-highlight-none'>
      {
        isLoading ? returnLoader()
          : companyStaff?.response?.map((staffData) => (
            <>
              {staffData.data?.length && staffData?.type === 'executives' ? (
                <>
                  <div className="d-flex justify-content-between mt-90 heading-here">
                    <h2 className="mt-c-30">
                      {staffData?.title?.length
                        ? (
                          <>
                            {`${staffData?.title}`}
                            {` (${formatNumberWithCommas(staffData.data?.length)})`}
                          </>
                        )
                        : ''}
                    </h2>
                  </div>
                  <Row className="Grid-width-row pt-2" gutter={[24, 24]}>
                    {staffData.data?.map((person) => (
                      <Col xxl={{ span: 4 }} xl={{ span: 4 }} lg={{ span: 6 }} className="gutter-row">
                        <DragWrapper key={(person as Executive)?.personId} isDrag={isDrag}>
                          <PeopleCardLarge
                            showDrawerIcon={!!(person as Executive).personNotes}
                            personName={(person as Executive).personName}
                            logo={(person as Executive).personImage}
                            persona={(person as Executive).archeType.color}
                            tag={(person as Executive).personDesignation}
                            follow={!(person as Executive).personAdded}
                            personaType={(person as Executive).archeType.name}
                            hidePersonality={false}
                            personAddedFlag={(person as Executive).personAdded}
                            personId={(person as Executive).personId}
                            personality={(person as Executive).personType}
                            company={(person as Executive).companyName}
                            personalityTypesColors={(person as Executive).personalityTypes}
                            wrapperColor={
                              backgroundColorParsing((person as Executive).personalityTypes)
                            }
                          />
                        </DragWrapper>
                      </Col>
                    ))}
                  </Row>
                </>
              ) : null}
              {staffData.data?.length && staffData?.type === 'followedStaff' ? (
                <div className="staff-i-follow">
                  <h2 className="mt-c-0">
                    {staffData?.title?.length
                      ? (
                        <>
                          {`${staffData?.title}`}
                          {` (${formatNumberWithCommas(staffData.data?.length)})`}
                        </>
                      )
                      : ''}
                  </h2>
                  <Row className="Grid-width-row" gutter={[24, 24]}>
                    {staffData.data?.map((person) => (
                      <Col
                        xxl={{ span: 4 }}
                        xl={{ span: 4 }}
                        lg={{ span: 6 }}
                        className="gutter-row"
                      >
                        <DragWrapper key={(person as Executive)?.personId} isDrag={isDrag}>
                          <PeopleCardLarge
                            showDrawerIcon={!!(person as Executive).personNotes}
                            personName={(person as Executive).personName}
                            logo={(person as Executive).personImage}
                            persona={(person as Executive).archeType.color}
                            tag={(person as Executive).personDesignation}
                            follow={!(person as Executive).personAdded}
                            personaType={(person as Executive).archeType.name}
                            hidePersonality={false}
                            personAddedFlag={(person as Executive).personAdded}
                            personId={(person as Executive).personId}
                            personality={(person as Executive).personType}
                            company={(person as Executive).companyName}
                            personalityTypesColors={(person as Executive).personalityTypes}
                            wrapperColor={
                              backgroundColorParsing((person as Executive).personalityTypes)
                            }
                          />
                        </DragWrapper>
                      </Col>
                    ))}
                  </Row>
                </div>
              ) : null}

            </>

          ))
      }
      {isLoading ? returnLoader()
        : companyStaff?.response?.map((staffData) => (
          staffData.data?.length && staffData?.type === 'buyerGroups'
            ? returnBuyersGroupPart(staffData as StaffBuyerGroup) : null
        ))}
      {
        !notableStaffLoading && notableStaff.length ? (
          <div className="staff-i-follow">
            <Row className="mt-c-50 mb-c-20 heading-text">
              <Col span={12}>
                <h2 className="mb-0">
                  {notableStaffTitle.length ? `${notableStaffTitle} (${formattedStaffCount})` : 'N/A'}
                </h2>
              </Col>
              <Col span={12} className="d-flex justify-content-end">
                <div className="staff-btn-style d-flex align-items-center">
                  {/* {disclessPersonality ? null : ( */}
                  <div
                    className="export-company"
                  >
                    <GlobalButton
                      title="Export"
                      textColor="#7E7E7E"
                      bgColor="#fff"
                      outlineColor="#DADADA"
                      innerSpace="5px 15px 5px 15px"
                      PaddingSm="5px 15px 4px 15px"
                      heightSm="30px"
                      LeftSpace="7px"
                      IconLeft={<ExportIcon />}
                      buttonClassName="share-button mr-24 export_btn"
                      rightSeparatorClassName="right-separator-class"
                      onButtonClick={handleExport}
                      disabled={notableStaffExportLoading}
                    />
                  </div>
                  {/* )} */}
                  {notableStaff.length > 15
                    && (
                      <ReadMore
                        onClick={() => {
                          dispatch(actions.resetExportNotableStaff());
                          navigate(`${NOTABLE_STAFF_ROUTE}${companyIdParsed}`);
                        }}
                        onKeyPress={() => {
                          dispatch(actions.resetExportNotableStaff());
                          navigate(`${NOTABLE_STAFF_ROUTE}${companyIdParsed}`);
                        }}
                        role="button"
                        aria-label="See more"
                        tabIndex={0}
                      >
                        See More
                        <ArrowRightIcon color={primaryColor} />
                      </ReadMore>
                    )
                  }
                </div >

              </Col >
            </Row >

            <Row gutter={[24, 10]} className="mb-90">
              {getExecutives(notableStaff)}
            </Row>
          </div >
        ) : notableStaffLoading
        && (
          <div className="mb-2">
            {notableStaff.length < 1 && (
              <div className="mt-c-50 heading-text">
                <SkeletonCustom width="340px" height="30px" />
              </div>
            )}
            <div className="mt-2">
              <Row gutter={[24, 10]} className="mb-90">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map(() => (
                  <Col span={8} xs={24} sm={24} md={12} lg={8}>
                    <PeopleCardListSkeleton />
                  </Col>
                ))}

              </Row>
            </div>
          </div>
        )
      }
    </Wrapper >
  );
};

export default React.memo(CompanyStaff);
